// ABOUTME: Checkbox checkmark icon for custom checkbox components
// ABOUTME: Supports className, size, and color customization

interface CheckboxCheckIconProps {
  className?: string
  size?: number
  color?: string
}

export const CheckboxCheckIcon = ({ className = "", size = 14, color = "currentColor" }: CheckboxCheckIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 13l4 4L19 7"
    />
  </svg>
)
